import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { subTaskService } from '../services/subTask.service';

export function useSubTask(workOrderId: string) {
  const [search, setSearch] = useState('');
  const [tab, setTab] = useState<'list' | 'trash'>('list');

  const infoQuery = useQuery({
    queryKey: ['work-order', 'info', workOrderId],
    queryFn: () => subTaskService.getWorkOrderInfo(workOrderId),
    enabled: !!workOrderId,
  });

  const listQuery = useQuery({
    queryKey: ['work-order', 'sub-tasks', workOrderId],
    queryFn: () => subTaskService.getSubTasks(workOrderId),
    enabled: !!workOrderId,
  });

  const filteredItems = (listQuery.data?.items || []).filter(item => 
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  return {
    info: infoQuery.data,
    items: filteredItems,
    stats: listQuery.data?.stats || { total: 0, completed: 0, inProgress: 0, pending: 0, overdue: 0, priorityStats: { high: 0, medium: 0, low: 0 } },
    isLoading: infoQuery.isLoading || listQuery.isLoading,
    search,
    setSearch,
    tab,
    setTab,
  };
}
